"use client"

import { HeadingText } from "@/components/atoms/HeadingText/heading-text"

export const ItemNotFound = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center space-y-6 px-4">
      {/* SVG Icon with Animation */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-24 w-24 animate-pulse text-gray-400"
      >
        <path d="M9 9v10a2 2 0 0 1-2 2H5l-3 3 3 3h6a2 2 0 0 0 2-2V9z" />
        <path d="M17 9v10a2 2 0 0 1-2 2h-4" />
      </svg>

      {/* HeadingText Component for Title */}
      <HeadingText level={3} className="text-3xl font-bold text-gray-800">
        Item Not Found
      </HeadingText>

      {/* Subtitle Explanation */}
      <p className="max-w-md text-center text-lg text-gray-600">
        The item you're looking for doesn't exist or has been removed.
      </p>
    </div>
  )
}
